module.exports = __webpack_public_path__ + "static/img/subway-04.4230f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subway-04.png
// module id = 149
// module chunks = 0